import { faSyncAlt } from "@fortawesome/free-solid-svg-icons/faSyncAlt";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
export default class Reload extends React.Component {
    render() {
        return (React.createElement(FontAwesomeIcon, { icon: faSyncAlt, ...{ size: "1x", color: "#00a555", ...this.props } }));
    }
}
